module.exports = __webpack_public_path__ + "img/probability_up_jp.573ae4fa.png";